<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      class="term_select"
      :value="this.selectValue"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker = true"
    />
    <van-popup
      v-model="showTermPicker"
      position="bottom"
      :style="{ height: '35%' }"
    >
      <div class="popupBox">
        <div class="handleHeader">
          <div class="cardBindManagement" @click="cardBindManagement">
            选择企业
          </div>
          <div @click="showTermPicker = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="handleContent">
          <div
            class="handleContentList"
            @click="
              () => {
                handeIndex(index, e)
              }
            "
            :class="{ select: index === Index }"
            v-for="(e, index) in corpNameList"
            :key="index"
          >
            <div class="corpInfo">
              <div>
                <span class="type">{{ e.text }}</span>
              </div>
            </div>
            <van-icon
              v-show="index === Index"
              :class="{ active: index === Index }"
              name="success"
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: ['label', 'placeholder', 'value'],
  data() {
    return {
      showTermPicker: false,
      model: 'test',
      Index: 0,
      selectValue: '',
      corpNameList: [
        {
          text: '法人',
          value: '1',
        },
        {
          text: '股东',
          value: '2',
        },
      ],
    };
  },
  watch: {
    value: {
      handler(val) {
        const data = this.corpNameList.filter((e) => e.value === val);
        if (data.length > 0) {
          this.selectValue = data[0].text;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handeIndex(i, value) {
      this.Index = i;
      this.selectValue = value.text;
      this.$emit('input', value.value);
      this.showTermPicker = false;
    },
    cardBindManagement() {
      this.$router.push(
        `/supermarket/v2/BindCardManage?orderId=${this.$router.currentRoute.query.orderId}`,
      );
    },
  },
};
</script>
<style scoped>
.van-field__label {
  text-align: left;
  width: 90px!important;
}
.term_select::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
.popupBox {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.handleHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
}
.handleContent {
  flex: 1;
  overflow: auto;
  background: #fff;
}
.handleContentInfo {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  margin-top: 40%;
}
.active {
  color: #ff6538;
}
.handleContentList {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.select {
  background: rgba(243, 242, 242, 0.644);
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cardBindManagement {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.corpInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
.corpName {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #001f33;
  margin-bottom: 8px;
}
.type {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
  margin-right: 4px;
}
.tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #a9b1bc;
}
.term_select >>> .van-field__label {
  text-align: left;
  width: 90px!important;


}
</style>
